import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {TherapeutenComponent} from './therapeuten/therapeuten.component';
import {UpsertTherapeutComponent} from './upsert-therapeut/upsert-therapeut.component';

@NgModule({
  declarations: [
    TherapeutenComponent,
    UpsertTherapeutComponent,
  ],
  imports: [
    CoreModule,
  ],
  exports: [
    TherapeutenComponent,
    UpsertTherapeutComponent,
  ],
})
export class TherapeutModule {
}
